import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import firebase from 'firebase/app';
import store from '@/store';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '*',
    redirect: '/sparks',
  },
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta: { hideNav: false },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "home" */ '../views/landing/Contact.vue'),
    meta: { hideNav: false },
  },
  {
    path: '/support',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "home" */ '../views/landing/Contact.vue'),
    meta: { hideNav: false },
  },
  {
    path: '/invite',
    redirect: '/',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Login.vue'),
    meta: { hideNav: true },
  },
  {
    path: '/signin',
    name: 'Signin',
    component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Login.vue'),
    meta: { hideNav: true },
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Signup.vue'),
    meta: { hideNav: true },
  },
  {
    path: '/profile',
    name: 'AccountOptions',
    component: () => import(/* webpackChunkName: "profile" */ '../views/profile/AccountOptions.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/profile/password',
    name: 'ChangePassword',
    component: () => import(/* webpackChunkName: "profile" */ '../views/profile/ChangePassword.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/profile/info',
    name: 'ProfileInfo',
    component: () => import(/* webpackChunkName: "profile" */ '../views/profile/ProfileEdit.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import(/* webpackChunkName: "profile" */ '../views/legal/PrivacyPolicy.vue'),
  },
  {
    path: '/terms',
    name: 'TermsOfService',
    component: () => import(/* webpackChunkName: "profile" */ '../views/legal/TermsOfService.vue'),
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: () => import(/* webpackChunkName: "profile" */ '../views/misc/Feedback.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/sparks',
    name: 'SparkList',
    component: () => import(/* webpackChunkName: "sparks" */ '../views/sparks/SparkList.vue'),
  },
  {
    path: '/sparks/:id',
    name: 'SparkView',
    component: () => import(/* webpackChunkName: "sparks" */ '../views/sparks/SparkView.vue'),
    props: true,
  },
  // {
  //   path: '/search',
  //   name: 'Search',
  //   component: () => import(/* webpackChunkName: "sparks" */ '../views/sparks/SparkSearch.vue'),
  // },
  // {
  //   path: '/sparks/tags/:id',
  //   name: 'SparkTag',
  //   component: () => import(/* webpackChunkName: "sparks" */ '../views/sparks/SparkTag.vue'),
  //   props: true,
  // },
  {
    path: '/dreams',
    name: 'DreamList',
    component: () => import(/* webpackChunkName: "dreams" */ '../views/dreams/DreamList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/dreams/add',
    name: 'DreamAdd',
    component: () => import(/* webpackChunkName: "dreams" */ '../views/dreams/DreamAdd.vue'),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/dreams/:id',
    name: 'DreamView',
    component: () => import(/* webpackChunkName: "dreams" */ '../views/dreams/DreamView.vue'),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/dreams/:id/edit',
    name: 'DreamEdit',
    component: () => import(/* webpackChunkName: "dreams" */ '../views/dreams/DreamEdit.vue'),
    props: true,
    meta: { requiresAuth: true },
  },
];

if (process.env.NODE_ENV == 'development') {
  routes.push(
    {
      path: '/test',
      name: 'Test',
      component: () => import(/* webpackChunkName: "test" */ '../views/test/Test.vue'),
      meta: { hideNav: false, requiresAuth: true },
    },
    {
      path: '/unsplash',
      name: 'Unsplash',
      component: () => import(/* webpackChunkName: "test" */ '../views/test/UnsplashTest.vue'),
      meta: { hideNav: false, requiresAuth: true },
    },
  );
}

function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { x: 0, y: 0 };
  }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const currentUser = firebase.auth().currentUser;

  const showNav = !(to.matched.some(x => x.meta.hideNav));
  store.commit('setShowNav', showNav);


  //If a user is not logged in and the page requires auth then save their destination
  //in local storage and direct them to the login page
  if (requiresAuth && !currentUser) {
    sessionStorage.setItem('redirectPath', to.path);
    next('/login');

    //If the page requires auth and the user is logged in then let them proceed
  } else if (requiresAuth && currentUser) {
    next();

    //If the user is logged in and trying to go to the home page then direct them to Sparks
  // } else if (to.path == '/' && currentUser) {
  //   //If a user is already logged in direct them to the Sparks page
  //
  //   store.commit('setShowNav', true);
  //   next('/sparks');

    //If the user is logged in and trying to go to the login/signup page then send them to their profile
  } else if ((to.path == '/login' || to.path == '/signin' || to.path == '/signup') && currentUser) {
    //If a user is already logged in direct them to the Sparks page
    next('/profile');

    //For everything else (no auth required and not logged in) then send them on their way
  } else {
    next();
  }
});


export default router;
